import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./About.css";
import BlogPreview from "../DiscoverBlogs";
import packkyImage from "../../assets/Why Choose us.webp";
import Grid from "../../assets/Grid.png";
import imag2 from "../../assets/a1.webp";
import imag3 from "../../assets/a2.webp";
import imagw from "../../assets/CTA.webp";
import DiscoverBlogs from "../DiscoverBlogs";

const AboutSection = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js"; 
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
     {/* <Navbar /> */}
      <div className="main-box-1 pt-5">
        <div className="main-box">
          <section className="about-us bg-light">
            <div className="container">
              {/* Subtitle and description */}
              <div className="row justify-content-center text-center mt-3">
                <div className="col-12">
                  <h5 className=" about-title" style={{ fontSize: "20px" }}>
                    ABOUT US
                  </h5>
                  <h2
                    className="fw-semibold revolution-title"
                    style={{ fontSize: "28px" }}
                  >
                    Transforming The Way <br />
                    <span>Businesses Deliver</span>
                  </h2>
                  <p className="text-center paragrapg-title fs-4 ">
                  In today’s fast-paced world, timely and reliable deliveries aren’t a luxury — they’re essential. At Packky (powered by Chaafo), our mission is to help businesses manage their logistics with speed, simplicity, and complete transparency. We’re building smarter tools that make deliveries seamless and stress-free, so you can focus on growing your business while we handle the last mile.
                  </p>
                </div>
              </div>

              {/* Background blur elements */}
              <div className="row">
                <div className="col-12 position-sticky"></div>
              </div>
            </div>
          </section>
        </div>

        <div className="main-box1 mt-5">
          <section className="about-us-2 bg-white">
            <div className="container">
              <div className="row mt-1 mt-md-0 g-3 mt-2 justify-content-center align-items-center">
                <div className="col-12 text-center mb-4">
                  <h3 className=" fw-bold" style={{ fontSize: "28px" }}>
                    Why Choose Us?
                  </h3>
                </div>

                <div className="col-md-6 col-12 text-center">
                  <img
                    src={packkyImage}
                    alt="About Us"
                    className="img-fluid rounded mb-5"
                  />
                </div>

                <div className="col-md-6 col-12">
                  <div className="mb-4">
                    <h4 className="fw-bold heading-text-4 mb-3">
                      Speed & Efficiency
                    </h4>
                    <p className="paragarp-text">
                      Optimized routing and instant notifications, we cut down
                      delivery times and enhance productivity.
                    </p>
                  </div>

                  <div className="mb-4">
                    <h4 className="fw-bold heading-text-4 mb-3">
                      Real-time Tracking
                    </h4>
                    <p className="paragarp-text">
                    Always know where your shipments are and keep customers informed with live updates.
                    </p>
                  </div>

                  <div className="mb-4">
                    <h4 className="fw-bold heading-text-4 mb-3">
                      Smart Automation
                    </h4>
                    <p className="paragarp-text">
                    Reduce manual errors with automated order processing and smooth fulfillment.
                    </p>
                  </div>

                  <div>
                    <h4 className="fw-bold heading-text-4 mb-3">
                      Scalability & Flexibility
                    </h4>
                    <p className="paragarp-text">
                    Whether 10 or 10,000 deliveries a day, Packky (powered by Chaafo) (powered by Chaafo) scales effortlessly with your business.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div
          className="main-box2 mt-1"
          style={{
            backgroundImage: `url(${Grid})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundColor: "rgba(240, 237, 252, 1)",
          }}
        >
          <section className="about-us-2">
            <div className="container">
              <div className="d-flex justify-content-center">
                <div className="main-box-box">
                  <div className="row mt-1">
                    <div className="col-12">
                      <h3
                        className="fw-bold mt-5 text-center"
                        style={{ fontSize: "28px" }}
                      >
                        Our Story
                      </h3>

                      {/* First Row */}
                      <div className="row g-3 mt-5 justify-content-center align-items-center">
                        <div className="col-md-6 col-12">
                          <div className="service-image-3">
                            <img src={imag2} alt="Service" />
                          </div>
                        </div>

                        {/* Right Side (Content) */}
                        <div className="col-md-6 col-12">
                          <div className="service-card-67">
                            <p style={{ color: "rgba(100, 160, 255, 1)" }} className="fs-4"> Where We Started </p>
                            <p className=" text-start text-secondary ">
                              
                              We began with a simple vision — to remove chaos from deliveries and create a system that works for everyone: businesses, drivers, and customers. What started as an idea has grown into a logistics platform that redefines efficiency and customer satisfaction.{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                      
                      <div className="row g-3 mt-1 mt-md-0 justify-content-center align-items-center">
                        {/* Text Column - Note the order change for mobile responsiveness */}
                        <div className="col-12 col-md-6 order-2 order-md-1">
                        <div className="service-card-67">
                            <p style={{ color: "rgba(179, 100, 255, 1)" }} className="fs-4"> Who We Are Today </p>
                            <p className=" text-start text-secondary ">
                            Our team is a mix of innovators and problem-solvers who believe the future of delivery should be fast, frictionless, and future-ready. Every feature we build aims to make your deliveries smarter, easier, and built for growth.
                            </p>
                          </div>
                        </div>

                        {/* Image Column */}
                        <div className="col-12 col-md-6 order-1 order-md-2">
                          <div className="service-image-3">
                            <img
                              src={imag3}
                              alt="Service"
                              className="img-fluid"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="main-box-5 card-h bg-light p-5" style={{ minHeight: "auto" }}>
  <section className="about-p">
    <div className="container">
      <div className="row mt-5">
        <div className="col-12">
          <div 
            className="banner-box3 mx-auto rounded-5 overflow-hidden position-relative"
            style={{
              background: "linear-gradient(-135deg, #FDFEFF 20%, #CEEBFF 70%, #129EFF 100%)",
              border: "0.5px solid #ccc",
              minHeight: "300px",
              maxWidth: "1200px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
            }}
          >
            <div className="row g-0 h-100">
              <div className="col-lg-7 col-md-6 col-12 d-flex flex-column justify-content-center p-4 p-md-5">
                <div className="banner-content">
                  <h4 className="text-dark fw-bold mb-3" style={{fontSize: "clamp(18px, 2.5vw, 24px)"}}>
                    Join the Future of Delivery
                  </h4>
                  <p className="mb-0" style={{ color: "#6B6B6B", fontSize: "clamp(14px, 1.5vw, 16px)" }}>
                  At Packky (powered by Chaafo), we go beyond being a service — we’re your logistics partner. Whether it’s last-mile deliveries, fleet management, or smooth integration with your existing systems, we’ve got you covered.
                  Let’s move your business forward, one delivery at a time.
                  </p>
                  <p className="mb-0" style={{ color: "#6B6B6B", fontSize: "clamp(14px, 1.5vw, 16px)" }}>
                    Let's move the world forward, one delivery at a
                    time.
                  </p>
                  <div className="mt-2">
                    <button className="btn btn-light fw-bold rounded-pill px-4 py-2 d-flex align-items-center" style={{width: "fit-content",marginTop:"15px"}}>
                      <span className="text-primary" style={{fontSize: "clamp(10px, 1.5vw, 16px)"}}>
                        Sign Up for Free{" "}
                        <i className="fas fa-arrow-right ms-2"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-6 col-12 d-flex align-items-end justify-content-center position-relative">
                <img
                  src={imagw}
                  alt="Service"
                  className="img-fluid"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "calc(100% - 20px)",
                    height: "auto",
                    objectFit: "contain",
                    objectPosition: "bottom right"
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
        <DiscoverBlogs />

        {/* <Footer/> */}
      </div>
    </>
  );
};

export default AboutSection;
